// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"B7-z","vrsnlCrossSiteLabel":"C7-z"};